import React, { useEffect } from 'react';
import Navbar from '../../composants/site/Navbar';
import Footer from '../../composants/site/Footer';
import './QuiSommesNous.css';

// Importation des images locales
import aboutHeroImg from '../../assets/images-sites/about.png';
import logoImg from '../../assets/images/logo.png';

const QuiSommesNous = () => {
    useEffect(() => {
        document.title = "LAMP | Qui sommes-nous ?";
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="site-page-about">
            <Navbar />

            {/* 1. HERO (Layout 2 colonnes avec image locale) */}
            <section className="about-hero position-relative d-flex align-items-center overflow-hidden">
                {/* Image de fond locale à droite */}
                <div 
                    className="about-hero-bg-side" 
                    style={{ backgroundImage: `url(${aboutHeroImg})` }}
                ></div>
                
                <div className="container about-hero-container py-5">
                    <div className="row align-items-center h-100">
                        {/* Texte à gauche */}
                        <div className="col-lg-7 animate__animated animate__fadeInLeft">
                            <span className="about-label text-uppercase fw-bold small mb-2 d-block">Notre identité</span>
                            <h1 className="display-4 fw-bold outfit text-white mb-4">
                                Une mission, une vision, <br /> un engagement.
                            </h1>
                            <p className="lead text-white opacity-85 mb-0" style={{ maxWidth: '600px' }}>
                                Découvrez l'histoire et les fondements de LAMP (La Lumière de la Parole), une structure d'édification au service du Royaume de Dieu.
                            </p>
                        </div>
                    </div>
                </div>
                {/* Couche de lumière/dégradé de transition */}
                <div className="about-hero-overlay-grad"></div>
            </section>

            {/* 2. CONTEXTE & GENÈSE */}
            <section className="about-story py-5 border-bottom">
                <div className="container py-lg-5">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-6 order-2 order-lg-1">
                            <span className="text-primary fw-bold text-uppercase small tracking-widest d-block mb-3">Notre Genèse</span>
                            <h2 className="outfit fw-bold text-dark display-5 mb-4">D'où venons-nous ?</h2>
                            <p className="text-muted fs-5 leading-relaxed mb-4">
                                L'église d'aujourd'hui est de plus en plus remplie de chrétiens qui sont dans l'effervescence et dans toute sorte d'agitation inutile, s'éloignant parfois de l'essentiel. LAMP est née pour restaurer cet équilibre vital.
                            </p>
                            <p className="text-muted fs-5 leading-relaxed">
                                Notre genèse est ancrée dans le désir profond de voir chaque enfant de Dieu devenir autonome et affermi, capable de puiser lui-même la lumière nécessaire à sa marche quotidienne.
                            </p>
                        </div>
                        <div className="col-lg-6 order-1 order-lg-2">
                             <div className="story-image-wrap rounded-5 overflow-hidden shadow-2xl">
                                <img src={aboutHeroImg} alt="bible focus" className="img-fluid w-100 h-100 object-cover" />
                             </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* 3. SYMBOLIQUE DU LOGO & SLOGAN (Psaume 119) */}
            <section className="about-logo-meaning py-5 bg-white">
                <div className="container py-lg-5">
                    <div className="row align-items-center g-5">
                        <div className="col-lg-5 text-center">
                            <div className="logo-box p-4 bg-light rounded-5 shadow-sm inline-block">
                                <img src={logoImg} alt="Logo LAMP" className="img-fluid" style={{ maxWidth: '180px' }} />
                                <h4 className="fw-bold text-dark mt-3 mb-0">Notre Sceau</h4>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <span className="badge bg-primary-subtle text-primary border border-primary-subtle rounded-pill px-3 py-2 mb-3">Fondement biblique</span>
                            <h2 className="outfit fw-bold text-dark mb-4">Le Slogan et le Logo</h2>
                            <p className="text-muted fs-5 mb-4">
                                Notre slogan, <strong className="text-primary">« À chaque pas, la lumière de la Parole de Dieu »</strong>, ainsi que notre logo, sont tous deux directement tirés du livre des <strong className="text-dark">Psaumes 119:105</strong> :
                            </p>
                            <div className="p-4 bg-light rounded-4 italic border-start border-4 border-primary mb-4 position-relative">
                                <i className="bi bi-quote position-absolute top-0 start-0 m-2 opacity-25 display-4"></i>
                                <p className="text-muted fs-5 mb-0 ps-3">
                                    "Ta parole est une lampe à mes pieds, et une lumière sur mon sentier."
                                </p>
                            </div>
                            <p className="text-muted fs-5">
                                Ces symboles rappellent que sans la révélation biblique, le chemin du croyant reste incertain. Nous croyons que la Parole est le guide suprême pour agir, décider et faire des choix conformes au plan de Dieu.
                            </p>
                        </div>
                    </div>
                </div>
            </section>


            {/* 4. MISSION & VISION */}
            <section className="about-mission-vision py-5 bg-light">
                <div className="container py-lg-5">
                    <div className="row g-4 justify-content-center text-center">
                        <div className="col-md-6 col-lg-5">
                            <div className="mv-card-simple p-4 p-lg-5 h-100">
                                <h3 className="outfit fw-bold text-primary mb-3">Notre Mission</h3>
                                <p className="text-muted mb-0">
                                    Rendre la méditation biblique accessible par des ressources de qualité, des retraites spirituelles et une communauté engagée, favorisant l'équilibre entre prière et étude.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-5">
                            <div className="mv-card-simple p-4 p-lg-5 h-100">
                                <h3 className="outfit fw-bold text-warning mb-3">Notre Vision</h3>
                                <p className="text-muted mb-0">
                                    Voir une génération de chrétiens profondément enracinés, capables de discerner la volonté de Dieu pour transformer durablement leurs communautés par l'évangile.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* 5. L'ÉQUIPE & LA COMMUNAUTÉ (Fusionné) */}
            <section className="about-team-community py-5 bg-white">
                <div className="container py-lg-5">
                    <div className="row g-5">
                        <div className="col-lg-6">
                            <h2 className="outfit fw-bold text-dark mb-4">Une Équipe Passionnée</h2>
                            <p className="text-muted fs-5 leading-relaxed">
                                L'équipe LAMP est constituée de prédicateurs, de missionnaires et de communicateurs dévoués qui travaillent chaque jour pour produire des ressources d'édification. Ce sont des hommes et des femmes de foi qui partagent une ambition commune : que la lumière de la Parole brille dans chaque foyer.
                            </p>
                        </div>
                        <div className="col-lg-6">
                            <h2 className="outfit fw-bold text-dark mb-4">Une Communauté Mondiale</h2>
                            <p className="text-muted fs-5 leading-relaxed">
                                Au-delà d'une organisation, LAMP est une véritable famille. Présents dans plus de 20 pays, nos milliers de membres forment une communauté soudée qui s'encourage quotidiennement dans la croissance spirituelle par le partage des témoignages et l'étude mutuelle.
                            </p>
                            <div className="row g-4 mt-2 text-center">
                                <div className="col-4">
                                    <h3 className="fw-bold text-primary mb-0">+10k</h3>
                                    <p className="small text-muted text-uppercase mb-0">Membres</p>
                                </div>
                                <div className="col-4 border-start border-end">
                                    <h3 className="fw-bold text-primary mb-0">+500</h3>
                                    <p className="small text-muted text-uppercase mb-0">Méditations</p>
                                </div>
                                <div className="col-4">
                                    <h3 className="fw-bold text-primary mb-0">20+</h3>
                                    <p className="small text-muted text-uppercase mb-0">Pays</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <Footer />
        </div>
    );
};

export default QuiSommesNous;
